module.exports = __webpack_public_path__ + "img/sel_Shenzhen.0870d7ce.png";